/**
 * Movento — bloco de preço (à vista no Pix + parcelamento).
 *
 * Reage à troca de variante do tema Horizon: quando o cliente seleciona outra
 * variante, a seção é re-renderizada e este componente troca o seu conteúdo
 * pelo conteúdo novo (mesmo padrão de product-price.js / product-inventory.js).
 */
import { morph } from '@theme/morph';
import { StandardEvents } from '@shopify/events';

class MoventoPrice extends HTMLElement {
  #section = null;

  connectedCallback() {
    this.#section = this.closest('.shopify-section, dialog');
    this.#section?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    this.#section?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    this.#section = null;
  }

  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const { html, newProduct } = detail;

        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const updated =
          html.querySelector(`movento-price[data-block-id="${this.dataset.blockId}"]`) ||
          html.querySelector('movento-price');

        if (!updated) return;

        morph(this, updated, { childrenOnly: true });
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[movento-price] evento rejeitado:', error);
      });
  };
}

if (!customElements.get('movento-price')) {
  customElements.define('movento-price', MoventoPrice);
}
